import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900"
            style={{ fontFamily: 'var(--font-heading)' }}>
            探索分类
          </h2>
          <p className="mt-2 text-sm text-foreground-600">
            按主题浏览，找到你最关心的人际关系话题
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center text-center p-4 md:p-5 bg-background-50 border border-background-200/60 rounded-xl cursor-pointer transition-all duration-300 hover:border-accent-300/50"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mb-3 group-hover:bg-accent-500 group-hover:text-white transition-all duration-300">
                <i className={`${cat.icon} text-xl`}></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1 whitespace-nowrap">
                {cat.name}
              </h3>
              <p className="text-xs text-foreground-500">
                {cat.articleCount} 篇文章
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}